import React from 'react';
import cn from 'classnames';
import s from './DetailsRightSide.scss';

interface Props {
  firstRow?: React.ReactNode;
  secondRow?: React.ReactNode;
  firstRowClassName?: string;
  secondRowClassName?: string;
}

const DetailsRightSide: React.FC<Props> = ({
  firstRow,
  secondRow,
  firstRowClassName,
  secondRowClassName,
}) => {
  return (
    <div className={s['root']}>
      <div className={cn(s['first-row'], firstRowClassName)}>{firstRow}</div>
      <div className={cn(s['second-row'], secondRowClassName)}>{secondRow}</div>
    </div>
  );
};
DetailsRightSide.displayName = 'DetailsRightSide';

export default DetailsRightSide;
